import React from 'react';
import { animated } from '@react-spring/web';

import Modal from '~/components/modals/modal';
import CheckoutSurveyForm from '~/components/modals/checkout-confirmation/checkout-survey-form';
import UpdatePasswordPage from '~/components/modals/checkout-confirmation/update-password-page';
import { useAnimatedPageTransitions } from '~/hooks/use-animated-page-transitions';
import { useSession } from '~/features/session/session-actions';

const pages = {
  INITIAL: 0,
  UPDATE_PASSWORD: 1,
};

const CheckoutConfirmationModal = ({ isOpen, onClose, cart }) => {
  const { user } = useSession();
  const passwordCreated = user?.passwordCreated;

  const { transitionTo, transitions, resetPage } = useAnimatedPageTransitions(
    pages.INITIAL
  );

  const handleClose = () => {
    resetPage();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {transitions((styleProps, item) => {
        switch (Number(item)) {
          case pages.INITIAL:
            return (
              <animated.div style={styleProps}>
                <CheckoutSurveyForm
                  cart={cart}
                  isOpen={isOpen}
                  transition={
                    passwordCreated
                      ? handleClose
                      : () => transitionTo(pages.UPDATE_PASSWORD, 1)
                  }
                />
              </animated.div>
            );
          case pages.UPDATE_PASSWORD:
            return (
              <animated.div style={styleProps}>
                <UpdatePasswordPage onClose={handleClose} />
              </animated.div>
            );
          default:
            return null;
        }
      })}
    </Modal>
  );
};

export default CheckoutConfirmationModal;
